module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am2.30350daa90c5f30b20f74ab89c90d02d.png";